import React from "react";

export default (props) => {

  return (
    <React.Fragment>

      <h1 className="page-title">About</h1>
      <p>This web application was built for the purpose to make it easier for people to submit requests for repairs to their property.</p>
      <p><strong> Requests for repairs will be sent to Homes For Haringey</strong></p>

    </React.Fragment>
  );
};
